import { SeatSelectionRuleName } from '../../types/seat-selection-rule-name';
const ruleName = SeatSelectionRuleName.MustRespectSeatSelectionLimits;
/**
 * Rule that checks if the number of seats selected satisfies the seat selection limits.
 */
export const mustRespectSeatSelectionLimitsRule = () => {
    return {
        name: ruleName,
        validate: (data, selectedSeats) => {
            const seatSelectionLimits = data.seatSelectionLimits;
            const baseLimitsViolated = selectedSeats.length < seatSelectionLimits.min || selectedSeats.length > seatSelectionLimits.max;
            if (!baseLimitsViolated && seatSelectionLimits.limitsPerAreaCategory !== undefined) {
                const areaCategoryLimits = seatSelectionLimits.limitsPerAreaCategory;
                const areaCategoryLimitsViolated = data.areaCategories.some(areaCategory => {
                    return hasAreaCategoryLimitBeenViolated(areaCategoryLimits, areaCategory.id, selectedSeats);
                });
                return {
                    ruleName: ruleName,
                    isValid: !areaCategoryLimitsViolated
                };
            }
            return {
                ruleName: ruleName,
                isValid: !baseLimitsViolated
            };
        }
    };
};
const hasAreaCategoryLimitBeenViolated = (areaCategoryLimits, areaCategoryId, selectedSeats) => {
    const areaCategoryLimit = areaCategoryLimits[areaCategoryId];
    if (areaCategoryLimit === undefined)
        return false;
    const seatsInCategory = selectedSeats.filter(seat => seat.areaCategoryId === areaCategoryId);
    return seatsInCategory.length < areaCategoryLimit.min || seatsInCategory.length > areaCategoryLimit.max;
};
